import { profileTypes } from '../../../config/constants/userConstants';

export function getPermissions(userProfile = {}, accountData = {}) {
  const isAdmin = userProfile.idProfile === profileTypes.ADMIN.id;
  const isMaster = userProfile.idProfile === profileTypes.MASTER.id;
  const isOperator = userProfile.idProfile === profileTypes.OPERATOR.id;
  const isTechnician = userProfile.idProfile === profileTypes.TECHNICIAN.id;

  return {
    canEditServices: isMaster || isAdmin || userProfile.administrateServices || userProfile.canCreateServices,
    enableAccountCustomization: accountData.enableAccountCustomization,
    enableAccountAPI: accountData.enableAccountAPI,
    manageAccounts: isMaster && userProfile.idAccount != null,
    canCreateIncidentNotes: isMaster || isAdmin || userProfile.canCreateIncidentNotes,
    canChangeServiceStatus: isAdmin || userProfile.canChangeServiceStatus,
    canAdministrateCustomers: isMaster || isAdmin || userProfile.administrateClients,
    administrateAdvancedAvailability:
      isMaster || isAdmin || ((isTechnician || isOperator) && userProfile.administrateAdvancedAvailability),
    canViewCustomers: isMaster || isAdmin || userProfile.canViewCustomers,
    canViewAssets: isMaster || isAdmin || userProfile.canViewAssets,
    canViewResourceTracking: isMaster || isAdmin || userProfile.canViewResourceTracking,
    canViewFinalCustomers: isMaster || isAdmin || userProfile.canViewFinalCustomers,
    canViewSurveys: isMaster || isAdmin || (isOperator && userProfile.canViewSurveys),
    canCreateCreditNotes: isMaster || isAdmin || (isOperator && userProfile.canCreateCreditNotes),
    canCreateAdjustmentNotes: isMaster || isAdmin || (isOperator && userProfile.canCreateAdjustmentNotes),
    canViewBillingSettings: isMaster || isAdmin || (isOperator && userProfile.canViewBillingSettings),
    canCreateInvoices: isMaster || isAdmin || (isOperator && userProfile.canCreateInvoices),
    administrateQuickAnswers: isMaster ||isAdmin || (isOperator && userProfile.administrateQuickAnswers),
    canDeleteIncidentNotes: isMaster || isAdmin || (isOperator && userProfile.canDeleteIncidentNotes),
    administrateInventory: isMaster || isAdmin || (isOperator && userProfile.administrateInventory),
    canViewServicesHistory: isMaster || isAdmin || isTechnician || (isOperator && userProfile.canViewServicesHistory),
  };
}
